import apiClient from './client';
import { piratenpostApiUrl } from '../utils/runtime';

const API_BASE = piratenpostApiUrl || '/wp-json/pfandpirat/v1/piratenpost';

function queryUrl(path, params = {}) {
  const url = new URL(`${API_BASE}${path}`, window.location.origin);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.set(key, value);
    }
  });
  return url.toString();
}

export function loadPiratenpostInbox() {
  return apiClient.get(`${API_BASE}/inbox`);
}

export function loadPiratenpostThread(threadId) {
  return apiClient.get(`${API_BASE}/thread/${threadId}`);
}

export function sendFlaschenpost(payload) {
  return apiClient.post(`${API_BASE}/send`, payload);
}

export function markPiratenpostThreadRead(threadId) {
  return apiClient.post(`${API_BASE}/thread/${threadId}/read`, {});
}

export function archivePiratenpostThread(threadId) {
  return apiClient.post(`${API_BASE}/thread/${threadId}/archive`, {});
}

export function searchPiratenpostUsers(search) {
  return apiClient.get(queryUrl('/users', { search }));
}

export function blockPiratenpostUser(userId) {
  return apiClient.post(`${API_BASE}/user/${userId}/block`, {});
}

export function reportPiratenpostMessage(messageId, reason) {
  return apiClient.post(`${API_BASE}/message/${messageId}/report`, { reason });
}
